import { useStateStore } from '../../stores/useStateStore';
import { RobotDevice } from '../types';
import { getRobotInfo } from './api';
import { robotInfoKeys } from './queries';

export const prefetchRobotDetails = async (robot: RobotDevice | undefined) => {
  const robotId = robot?.id;
  const robotIp = robot?.websocketConnection?.ipAddress;

  if (!robotId || !robotIp) {
    return undefined;
  }

  const queryClient = useStateStore.getState().query_client;

  await queryClient.prefetchQuery({
    queryKey: robotInfoKeys.all(robotId),
    queryFn: () => getRobotInfo(robotIp),
  });
};
